
























import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import { getHrefByLinkType } from '@/composition/getHrefByLinkType'

@Component
class BlockRequisitesItem extends Vue {
  @Prop() readonly item: Object = {}
  static options: any
}

export default defineComponent({
  name: 'BlockRequisitesItem',
  props: BlockRequisitesItem.options.props,

  setup() {
    return { getHrefByLinkType }
  },
})
